var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPound = function SvgPound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fill: "#683f8c",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256
  })), /*#__PURE__*/React.createElement("path", {
    d: "m334.6 329.424 19.164 42.236c-6.744 3.668-14.524 6.652-23.328 8.96-8.816 2.308-17.36 3.456-25.64 3.456-10.648 0-24.844-2.516-42.584-7.544-17.748-5.028-30.88-7.54-39.396-7.54-14.436 0-29.164 5.144-44.184 15.436l-18.988-42.944c13.368-9.584 22.98-19.784 28.836-30.608s8.784-21.14 8.784-30.956c0-3.2-.24-6.572-.712-10.116h-36.908v-39.216h27.86c-4.852-13.956-7.276-28.092-7.276-42.416 0-12.896 3.516-25.2 10.56-36.912 7.036-11.712 17.004-20.608 29.9-26.704 12.892-6.092 26.972-9.14 42.236-9.14 23.304 0 41.88 5.888 55.72 17.656s22.296 28.656 25.376 50.656l-48.084 7.096c-2.252-12.656-6.336-21.76-12.248-27.324-5.916-5.564-13.308-8.34-22.18-8.34-9.468 0-17.332 3.164-23.6 9.492-6.272 6.328-9.404 14.284-9.404 23.868 0 4.968.856 11.536 2.572 19.696 1.716 8.164 3.816 15.616 6.3 22.364h55.36v39.216h-47.2c.356 2.6.532 5.208.532 7.808 0 9.348-1.772 17.984-5.324 25.908-3.548 7.924-10.824 18.34-21.828 31.236 6.504-3.308 14.668-4.968 24.488-4.968 4.14 0 7.864.24 11.176.712 1.656.24 6.504 1.364 14.552 3.372 14.312 3.668 24.072 5.5 29.28 5.5 9.22 0 21.292-3.308 36.188-9.94z",
    style: {
      fill: "#f5f5f5"
    }
  }));
};
export default SvgPound;